import { Paths } from '../../../lib/constants/path'
import { RoleEnum } from '../../../lib/types/enums/users/role.enum'
import { Route } from '../../../lib/types/routes'
import MedicalTermCreatePage from './medical-term-create'
import MedicalTermListPage from './medical-term-list'
import MedicalTermUpdatePage from './medical-term-update'

const medicalTermRoutes: Route[] = [
  {
    path: Paths.MEDICAL_TERM_LIST_PAGE,
    element: <MedicalTermListPage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.MEDICAL_TERM_CREATE_PAGE,
    element: <MedicalTermCreatePage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.MEDICAL_TERM_UPDATE_PAGE,
    element: <MedicalTermUpdatePage />,
    roles: [RoleEnum.ADMIN]
  }
]

export default medicalTermRoutes
